var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('b-nav',{staticClass:"flex-column flex-nowrap sidebar"},[_c('leftsidebarquicklinks'),_vm._v(" "),_c('leftsidebarrecent'),_vm._v(" "),_c('leftsidebarbooks'),_vm._v(" "),_c('leftsidebarimports'),_vm._v(" "),_c('leftsidebartags')],1)}
var staticRenderFns = []

export { render, staticRenderFns }